import { render, staticRenderFns } from "./FormDatePickerV2.vue?vue&type=template&id=236e9b86&"
import script from "./FormDatePickerV2.vue?vue&type=script&lang=ts&"
export * from "./FormDatePickerV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports